import groupBy from 'lodash.groupby';
import { BlacklistUserInfoGeneralTypes } from './types';
import AdditionalSegment from './additional-segment';

import cn from './blacklist.module.css';

const BlacklistUserInfoAdditionalSegments = ({
  info,
}: BlacklistUserInfoGeneralTypes) => {
  let grouped: any = {};

  if (
    info?.source?.entitySegments?.additionalSegments &&
    info?.source?.entitySegments?.additionalSegments?.length
  ) {
    grouped = groupBy(
      info?.source?.entitySegments?.additionalSegments,
      (match) => match.type,
    );
  }

  return (
    <div className={cn.userInfoContent}>
      {Object.keys(grouped)?.map((key) => (
        <AdditionalSegment
          key={key.split(' ').join('-').toLowerCase()}
          segment={grouped[key]}
          title={key}
        />
      ))}
      {(!info?.source?.entitySegments?.additionalSegments ||
        !info?.source?.entitySegments?.additionalSegments?.length) && (
        <div className={cn.emptyAdditionalSegment}>
          No additinal segment yet
        </div>
      )}
    </div>
  );
};

export default BlacklistUserInfoAdditionalSegments;
